// @flow
import React, { useCallback, useEffect } from 'react';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { map } from 'lodash';
import { recordActions } from '@context/records';
import { Icon, Button, HMLDOMInjector } from '@elements';
import { handleMomenti18n, isPresent, useTranslationNs, useIsMobile } from '@helpers/helpers';

type MemedMedicationITem = {
  name: string,
  posology: string | null,
  quantity: number | null,
  unit: string | null,
}

type Props = {
    recordId: number,
    prescription: {
      id: number,
      has_content: boolean,
      medications: MemedMedicationITem[],
    };
};

const RecordPrescription = ({ recordId, prescription }: Props) => {
  const [, i18n] = useTranslationNs('timeline');

  useEffect(() => handleMomenti18n(i18n, moment), [i18n]);

  const dispatch = useDispatch();

  const [isMobile] = useIsMobile();

  const showPrintButton = Boolean(prescription.has_content);

  const onPrintClick = useCallback(() => {
    dispatch(recordActions.showMemedPrescriptionPDF(recordId, prescription.id));
  }, [dispatch, recordId, prescription.id]);

  const medications = prescription.has_content ? prescription.medications : [];

  return (
    <div className="memedPrescriptionRecord">
      <div>
        <div className="title">
          Receituário Memed
          {showPrintButton && !isMobile && (
            <React.Fragment>
              <Button onClick={onPrintClick} className="btn outlineButton downloadBtn memedActionButton">
                <Icon iconName="print" className="icon" size={18} />&nbsp;Imprimir
              </Button>
            </React.Fragment>
          )}

          {showPrintButton && isMobile && (
            <React.Fragment>
              <Button onClick={onPrintClick} className="btn outlineButton newShareFeature buttonLike downloadBtn memedActionButton shareMemedPrescription">
                <Icon iconName="share" className="icon" size={18} />
              </Button>
            </React.Fragment>
          )}
          <br/>
        </div>
      </div>

      {prescription.has_content && (
        <table
          className={classNames('table medicationsList', 'animate__animated animate__fadeIn')}
        >
          {map(medications, (medication: MemedMedicationITem) => (
            <tr>
              <td className="medicationTd">
                <div className="medicationTd-title">{medication.name}</div>
                {!!medication.posology && (
                <div className="medicationTd-posology">
                  {/* Memed's posology is HTML, posted from the browser with the prescription: keep its formatting only */}
                  <HMLDOMInjector as="div" __html={medication.posology} />
                </div>
                )}
                {!!medication.quantity && medication.quantity > 0 && (
                <div className="medicationTd-quantity-label">
                  <label>Qtd: </label>
                  <span>{medication.quantity}{medication.unit ? ` ${medication.unit}` : ''}</span>
                </div>
                )}
                {medication.quantity === 0 && isPresent(medication.unit) && (
                <div className="medicationTd-quantity-label">
                  <label>{medication.unit}</label>
                </div>
                )}
              </td>
            </tr>
          ))}
        </table>
      )}
    </div>
  );
};


// $FlowFixMe
export default React.memo(RecordPrescription);
